import { translate } from '../../../Internationalization';
import BaseButton from '../../../../shared/BaseButton/BaseButton';
import React from 'react';

/**
 * @param {{loadMore: boolean; onClick: ()=>void}} props
 * @returns {JSX.Element | null}
 */
export default function LoadMore(props) {
	if (!props.loadMore) {
		return null;
	}

	return (
		<div className="flex justify-center">
			<BaseButton onClick={props.onClick}>
				{translate('global.forms.buttons.load_more')}
			</BaseButton>
		</div>
	);
}
